import React, { Component } from 'react';
import * as Config from './../../config/Config';
import * as Common from './../../helpers/Common';
import * as User from './../../helpers/User';
import Linecharts from './../../components/Linecharts';
const $ = window.$;

//const $=window.$;
// const win=window;

class MyPerformance extends Component {
    constructor(props) {
        super(props);

        this.state = {
            chart: '',
            dynamic_li: [],
            lrroom: [],
            dlrroom: [],
            reporttemp: [],
            reporttemp2: [],
            module_wise: [],
            module_wise_main: [],
            module_wise_linechart: [],
            //mod_option:[],
            //dlr_module_wise:[],
            lr_dlr_module_wise: [],
            //dlr_module_wise_main:[],
            //dlr_module_wise_linechart:[],
            lrdlrmodulewise_linechart: [],
            //dlr_mod_option:[]
            lr_dlr_mod_option: [],


        };

    }
    fnChart() {
        let select_module = $("#select_module").val();
        $(".all_module").css('display', 'none');
        $("#moduleContainer" + select_module).css('display', 'block');

    }

    dlrfnChart() {
        let select_module = $("#dlr_select_module").val();
        $(".dlr_all_module").css('display', 'none');
        $("#dlrmoduleContainer" + select_module).css('display', 'block');

    }

    getAssesStatus(type) {
        this.props.switchPanel(type)
    }
    getTabs() {
        window.$('#parentHorizontalTab').easyResponsiveTabs({
            type: 'default', //Types: default, vertical, accordion
            width: 'auto', //auto or any width like 600px
            fit: true, // 100% fit in a container
            //closed: 'accordion', // Start closed if in accordion view
            tabidentify: 'hor_1', // The tab groups identifier
            activate: function (event) { // Callback function if tab is switched

                var $tab = $(this);
                var $info = $('#nested-tabInfo');
                var $name = $('span', $info);

                $name.text($tab.text());

                $info.show();
            }
        });

        window.$('#ChildVerticalTab_1').easyResponsiveTabs({
            type: 'vertical',
            width: 'auto',
            fit: true,
            tabidentify: 'ver_1', // The tab groups identifier
            //resp-tab-active
            /* activate: function (event) { // Callback function if tab is switched
                 alert('sdf');
                $('[aria-controls="ver_1_tab_item-2"]').click();
                alert('dd');
             } */
        });
    }
    getPerformance() {
        let learnerID = Common.getUserData("id", true);
        let pinNo = Common.getUserData("pinNo", true);
        let pinID = Common.getUserData("pinID", true);
        let corporateID = Common.getUserData("corporateID", true);
        let productID = Common.getUserData("productID", true);
        let specialExpiryDate = Common.getUserData("specialExpiryDate", true);

        Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl + 'learning/my-performance', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify({
                learnerID: learnerID,
                pinNo: pinNo,
                pinID: pinID,
                corporateID: corporateID,
                productID: productID
            })
        }).then((response) => response.json())
            .then((responseJson) => {

                let data = [
                    {
                        name: 'Completed',
                        y: '3',
                        sliced: true,
                        selected: true
                    }, {
                        name: 'Pending',
                        y: '2'
                    }];
                $(".timebox_new").css('display', 'block');
                $(".myperformance").css('display', 'block');
                if (responseJson.status != 0) {
                    let dynamic_li = (responseJson.myperformance.dynamic_li != undefined) ? responseJson.myperformance.dynamic_li : '';
                    let lrroom = (responseJson.myperformance.lrroom != undefined) ? responseJson.myperformance.lrroom : '';
                    let dlrroom = (responseJson.myperformance.dlrroom != undefined) ? responseJson.myperformance.dlrroom : '';
                    let reporttemp = (responseJson.myperformance.reporttemp != undefined) ? responseJson.myperformance.reporttemp : '';
                    let reporttemp2 = (responseJson.myperformance.reporttemp2 != undefined) ? responseJson.myperformance.reporttemp2 : '';

                    let module_wise = (responseJson.myperformance.module_wise != undefined) ? responseJson.myperformance.module_wise : '';



                    let module_wise_main = (responseJson.myperformance.module_wise_main != undefined) ? responseJson.myperformance.module_wise_main : '';
                    let dlr_module_wise_main = (responseJson.myperformance.dlr_module_wise_main != undefined) ? responseJson.myperformance.dlr_module_wise_main : '';
                    let module_wise_linechart = '';

                    if (module_wise_main.str_tot_scr != undefined) {
                        module_wise_linechart = <Linecharts belowtitle="Learning Rooms" key={`chart_3`} data={module_wise_main.str_tot_scr} title="Module Wise" categories={module_wise_main.module_name} name='Learning Rooms' charttype='line' />
                    }

                    //merge lr and dlr array
                    let lrdlrmodulewise = { "module_name": [], "str_tot_scr": [] };

                    if (module_wise_main['module_name'] != undefined && module_wise_main['module_name'].length > 0)
                        Array.prototype.push.apply(lrdlrmodulewise.module_name, module_wise_main['module_name']);


                    if (module_wise_main['str_tot_scr'] != undefined && module_wise_main['str_tot_scr'].length > 0)
                        Array.prototype.push.apply(lrdlrmodulewise['str_tot_scr'], module_wise_main['str_tot_scr']);


                    if (dlr_module_wise_main['module_name'] != undefined && dlr_module_wise_main['module_name'].length > 0)
                        Array.prototype.push.apply(lrdlrmodulewise['module_name'], dlr_module_wise_main['module_name']);

                    if (dlr_module_wise_main['str_tot_scr'] != undefined && dlr_module_wise_main['str_tot_scr'].length > 0)
                        Array.prototype.push.apply(lrdlrmodulewise['str_tot_scr'], dlr_module_wise_main['str_tot_scr']);


                    //console.log(lrdlrmodulewise);


                    let mod_option = (responseJson.myperformance.mod_option != undefined) ? responseJson.myperformance.mod_option : '';
                    //alert(JSON.stringify(module_wise_linechart));
                    let dlr_module_wise = (responseJson.myperformance.dlr_module_wise != undefined) ? responseJson.myperformance.dlr_module_wise : '';

                    //merge lr and dlr array
                    let lr_dlr_module_wise = [];
                    if (module_wise != '') {
                        //set flag lr or dlr (lr:1,Dlr:2)
                        for (var y = 0; y < module_wise.length; y++) {
                            module_wise[y]['lrdlrflag'] = '1';
                        }
                        Array.prototype.push.apply(lr_dlr_module_wise, module_wise);

                    }

                    if (dlr_module_wise != '') {
                        //set flag lr or dlr (lr:1,Dlr:2)
                        for (var z = 0; z < dlr_module_wise.length; z++) {
                            dlr_module_wise[z]['lrdlrflag'] = '2';
                        }
                        Array.prototype.push.apply(lr_dlr_module_wise, dlr_module_wise);
                    }

                    // console.log(lr_dlr_module_wise);
                    //  let dlr_module_wise_linechart = <Linecharts key={`chart_3`} data={dlr_module_wise_main.str_tot_scr} title="Dlr Module Wise" categories={dlr_module_wise_main.module_name} name='Dynamic Learning Rooms' charttype='line' />

                    let lrdlrmodulewise_linechart = <Linecharts belowtitle="Learning Rooms and Dynamic Learning Rooms" key={`chart_3`} data={lrdlrmodulewise.str_tot_scr} title="LR & DLR Module Wise" categories={lrdlrmodulewise.module_name} name='Learning Rooms and Dynamic Learning Rooms' charttype='line' />



                    let dlr_mod_option = (responseJson.myperformance.dlr_mod_option != undefined) ? responseJson.myperformance.dlr_mod_option : '';

                    //merge lr and dlr array
                    let lr_dlr_mod_option = [];

                    if (mod_option != '')
                        Array.prototype.push.apply(lr_dlr_mod_option, mod_option);

                    if (dlr_mod_option != '')
                        Array.prototype.push.apply(lr_dlr_mod_option, dlr_mod_option);

                    // console.log(lr_dlr_mod_option);


                    this.setState({
                        myperformance: responseJson.myperformance,
                        dynamic_li: dynamic_li,
                        lrroom: lrroom,
                        dlrroom: dlrroom,
                        reporttemp: reporttemp,
                        reporttemp2: reporttemp2,
                        module_wise: module_wise,
                        module_wise_linechart: module_wise_linechart,
                        //  mod_option:mod_option,
                        //dlr_module_wise:dlr_module_wise,
                        lr_dlr_module_wise: lr_dlr_module_wise,
                        //dlr_module_wise_linechart:dlr_module_wise_linechart,										 
                        lrdlrmodulewise_linechart: lrdlrmodulewise_linechart,
                        //dlr_mod_option:dlr_mod_option
                        lr_dlr_mod_option: lr_dlr_mod_option,
                    });
                    this.getTabs();
                    Common.downTabClose();
                    setTimeout(() => {

                        Common.reactLoader("hide");
                        $(".myjourney-table").tablesorter({ widthFixed: true });
                    }, 3000);

                }

            });
    }

    componentDidMount() {
        $(".timebox_new").css('display', 'none');

        $(".myperformance").css('display', 'none');

        setTimeout(() => {
            this.getPerformance();

            //Common.showSmallLeftMenu();				

        }, 500);
    }
  

    getLrinfo(type, lr_id, dlr_id) {
        this.props.switchPanel(type, lr_id, dlr_id);
    }

    render() {


        /* hide 
        let dynamic_li_list = null;
        if(this.state.dynamic_li != null || this.state.dynamic_li != undefined){
            dynamic_li_list=this.state.dynamic_li.map((key,index)=>{
                 return <li className={`${index==0?'resp-tab-active':''}`} key={`ver_1_tab_item-${index}`}>{key}<br />
                     <span></span></li>
            });
        }
        */
        let dynamic_li_list = <div><li className={`resp-tab-active`}>LRs-wise<br /><span></span></li><li>DLRs-wise<br /><span></span></li><li>Module-wise<br /><span></span></li></div>



        let lrrooms = null;
        if (this.state.lrroom != null || this.state.lrroom != undefined) {
            lrrooms = this.state.lrroom.map((key, index) => {
                return <Linecharts belowtitle="Learning Rooms" key={`chart_${index}`} data={key['lr_roomscore']} title={key['title']} categories={key['data_cat']} name='Learning Rooms' charttype='line' />
            });
        }
        let module_wise = null;
        if (this.state.module_wise != null || this.state.module_wise != undefined) {
            module_wise = this.state.module_wise.map((key, index) => {
                return <div key={`mod-wise${index}`} style={{ display: 'none' }} className="all_module" id={`moduleContainer${index}`}><Linecharts key={`chart_2`} data={key['lrMod_roomscore']} title={key['title']} categories={key['data_cat']} name='Learning Rooms' belowtitle="Learning Rooms" charttype='line' /></div>
            });
        }
        /*	let mod_option = null;
            if(this.state.mod_option != null || this.state.mod_option != undefined){
                mod_option= this.state.mod_option.map((key,index)=>{
                    return <option key={`mod-${index}`} value={index}>{key['module_name']}</option>
                });
            }
            */
        let dlrrooms = null;
        if (this.state.dlrroom != null || this.state.dlrroom != undefined) {
            dlrrooms = this.state.dlrroom.map((key, index) => {
                return <Linecharts belowtitle="Dynamic Learning Rooms" key={`dlr_chart_${index}`} data={key['lr_roomscore']} title="Dynamic Learning Rooms" categories={key['data_cat']} name='Learning Rooms' charttype='line' />
            });
        }
		/*
		let dlr_module_wise = null;
		if(this.state.dlr_module_wise != null || this.state.dlr_module_wise != undefined){
			dlr_module_wise= this.state.dlr_module_wise.map((key,index)=>{
				return <div key={`dlr_module_wise-${index}`} style={{display:'none'}} className="dlr_all_module" id={`dlrmoduleContainer${index}`}><Linecharts key={`dlr_chart_2`} data={key['lrMod_roomscore']} title={key['title']} categories={key['data_cat']} name='Learning Rooms' charttype='line' /></div>
			});
		}
		*/

        let lr_dlr_module_wise = null;
        if (this.state.lr_dlr_module_wise != null || this.state.lr_dlr_module_wise != undefined) {
            lr_dlr_module_wise = this.state.lr_dlr_module_wise.map((key, index) => {
                return <div key={`lr_dlr_module_wise-${index}`} style={{ display: 'none' }} className="dlr_all_module" id={`dlrmoduleContainer${index}`}><Linecharts  belowtitle={(key['lrdlrflag']=='1')?'Learning Rooms':'Dynamic Learning Rooms'}  key={`dlr_chart_2`} data={key['lrMod_roomscore']} title={key['title']} categories={key['data_cat']} name={(key['lrdlrflag']=='1')?'Learning Rooms':'Dynamic Learning Rooms'} charttype='line' /></div>
            });
        }


        // let dlr_mod_option = null;
        // if(this.state.dlr_mod_option != null || this.state.dlr_mod_option != undefined){
        // 	dlr_mod_option= this.state.dlr_mod_option.map((key,index)=>{
        // 		return <option key={`dlrmod-${index}`} value={index}>{key['module_name']}</option>
        // 	});
        // }

        let lr_dlr_mod_option = null;
        if (this.state.lr_dlr_mod_option != null || this.state.lr_dlr_mod_option != undefined) {
            lr_dlr_mod_option = this.state.lr_dlr_mod_option.map((key, index) => {
                return <option key={`lrdlrmod-${index}`} value={index}>{key['module_name']}</option>
            });
        }

        let reporttemps = null;
        if (this.state.reporttemp != null || this.state.reporttemp != undefined) {
            reporttemps = this.state.reporttemp.map((key, index) => {
                return <tr key={`temp-tr-${index}`} className="oddbg">
                    <td>{key['room']}</td>
                    <td>{key['module_name']}</td>
                    <td>{key['component_name']}</td>
                    <td>{key['ka']}</td>
                    {(key['asms'] == "YTA") ? <td><a href="javascript:void(0);" onClick={(e) => this.getAssesStatus('assessement_status')} title="My assessement status">{key['asms']}</a></td> : <td>{key['asms']}</td>}
                    <td>{key['percentage']}</td>
                    <td >{key['g_percentage']}</td>
                    <td>{key['u_percentage']}</td>
                </tr>
            });
        }


        return (

            <section id="contentsection" className="contentarea">
                <div className="inner-title-bg journey-tit-bg">
                    <h1> <span> <img src={process.env.PUBLIC_URL + '/images/img-myperformance.jpg'} align="absmiddle" alt="" border="0" /> </span> My Performance<br />
                        <span className="subtitle">My cumulative performance in completed Learning Rooms.</span></h1>
                </div>

                <div className="myperformance">
                    <section id="semana-scroll-inner" className="scroll">
                        <section className="viewport">
                            <section className="overview">
                                <div className="inner-content">

                                    <div id="parentHorizontalTab">
                                        <ul className="resp-tabs-list hor_1 horizontaltabbg ">
                                            <li>Performance Chart
					          <div className="activearrow"><img src={process.env.PUBLIC_URL + '/images/activetab.png'} alt="" title="" border="0" /></div>
                                            </li>
                                            <li>Percentile Report
					          <div className="activearrow"><img src={process.env.PUBLIC_URL + '/images/activetab.png'} alt="" title="" border="0" /></div>
                                            </li>

                                        </ul>

                                        <div className="resp-tabs-container hor_1 tapmargntop" id="responsivediv_show">
                                            <div className="tab-content">
                                                <div id="ChildVerticalTab_1">
                                                    <ul className="resp-tabs-list ver_1">
                                                        {dynamic_li_list}
                                                    </ul>
                                                    <div className="resp-tabs-container ver_1">
                                                        <div className="verticaltab-content">
                                                            <div key={`lrwise`} className="performance-chart">
                                                                {(lrrooms != '') ?
                                                                    <div>{lrrooms}
                                                                        <div className="chartstatuscontent">My Performance Score in each Learning Room.</div>
                                                                    </div>

                                                                    :
                                                                    <div className="timebox_new">Please complete at least one Learning Room to view this performance chart.</div>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* <div className="verticaltab-content">
					              {(this.state.module_wise_linechart!='') ?
					              <div>
					                <div key={`dlr-wise`} className="performance-chart">
					                  <div id="moduleContainer">{this.state.module_wise_linechart}</div>					                  
					                  <div className="chartselectoption">
					                    <div className="selectoptionright">
					                    {mod_option ?
					                    	<div>
						                      <label className="greentxt">Select Module :</label>
						                      <select name="select_module" id="select_module" onChange={(e)=>this.fnChart()} >
						                        <option value="">Select</option>
						                        {mod_option}						                        
						                      </select>
						                      </div>
						                      :
						                      <div></div>
						                  }
					                    </div>

					                     {(module_wise!='')?
						              		<div>{module_wise}
						              		</div>						                  
						              		:
						                	''
						            	}
					                  </div>
					                 
					                </div>
					                <div className="chartstatuscontent">My Performance Score in each Learning Room.</div>
					                </div>
					                :
					                <div className="timebox_new">Please complete at least one Learning Room to view this performance chart.</div>
					            }
					              </div> */}

                                                        <div className="verticaltab-content">
                                                            {(dlrrooms != '') ?
                                                                <div>{dlrrooms}</div>
                                                                :
                                                                <div className="timebox_new">Please complete at least one Dynamic Learning Room to view this performance chart.</div>
                                                            }
                                                        </div>


                                                        <div className="verticaltab-content">
                                                            {(lr_dlr_module_wise != '') ?
                                                                <div>
                                                                    <div id="dlrmoduleContainer">{this.state.lrdlrmodulewise_linechart}</div>

                                                                    <div className="chartselectoption">
                                                                        <div className="selectoptionright">
                                                                            {lr_dlr_mod_option ?
                                                                                <div>
                                                                                    <label className="greentxt">Select Module :</label>
                                                                                    <select name="dlr_select_module" id="dlr_select_module" onChange={(e) => this.dlrfnChart()} >
                                                                                        <option value="">Select</option>
                                                                                        {lr_dlr_mod_option}

                                                                                    </select>
                                                                                </div>
                                                                                :
                                                                                <div></div>
                                                                            }
                                                                        </div>

                                                                        <div>{lr_dlr_module_wise}</div>



                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="timebox_new">Please complete at least one Dynamic Learning Room to view this performance chart.</div>}
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>

                                            <div className="tab-content table-cont4">
                                                <div className="abbrevation">
                                                    <ul>
                                                        <li><strong>K/A</strong> - Knowledge / Action Component</li>
                                                        <li><strong>AS</strong> - Actual Score </li>
                                                        <li><strong>MS</strong> - Maximum Score</li>
                                                        <li><strong>%</strong> - Percentage Score</li>
                                                        <li><strong>G %ile</strong> - Group Percentile</li>
                                                        <li><strong>U %ile</strong> - Universal Percentile</li>
                                                    </ul>
                                                </div>
                                                <br />
                                                <table cellPadding="0" cellSpacing="0" border="0" width="100%" className="myjourney-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Rooms <img src={process.env.PUBLIC_URL + '/images/sort-arrow.png'} alt="" title="" /></th>
                                                            <th>Module Name <img src={process.env.PUBLIC_URL + '/images/sort-arrow.png'} alt="" title="" /></th>
                                                            <th>Component Name</th>
                                                            <th>K/A <img src={process.env.PUBLIC_URL + '/images/sort-arrow.png'} alt="" title="component - Indicates components that test knowledge / component - Indicates components that are action or practice based" /></th>
                                                            <th>AS/MS <img src={process.env.PUBLIC_URL + '/images/sort-arrow.png'} alt="" title="Indicates the actual scores made by the learner / Indicates the maximum score out of which the learner's performance was measured" /></th>
                                                            <th>% <img src={process.env.PUBLIC_URL + '/images/sort-arrow.png'} alt="" title="Indicates the percentage score made by the learner so far (AS divided by MS" /></th>
                                                            <th>G %ile <img src={process.env.PUBLIC_URL + '/images/sort-arrow.png'} alt="" title="Indicates the learner's position among the current group of learners" /></th>
                                                            <th>U %ile <img src={process.env.PUBLIC_URL + '/images/sort-arrow.png'} alt="" title="Indicates the learner's universal position among all the group of learners as on date" /></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {reporttemps}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </section>
                    </section>
                </div>


            </section>
        );

    }
}

export default MyPerformance;



// WEBPACK FOOTER //
// ./src/learning_records/my_performance/MyPerformance.js